/**
 * 批量新增用户
 */
import React from 'react';
import {Button, Row, Col} from "antd";
import CmModal from "../../../../components/CmModal/CmModal";
import {message} from "../../../../view/sysManagement/utils/sysManagementUtils";
import BaseComponent from "../../../../base/BaseComponent";
import UploadWall from "../../../../components/upload/UploadWall";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import {rmtMessage} from "../../../../view/mediaRelease/components/mess";

export default class BatchAddUser extends BaseComponent {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            batchAddUserVisible: false,
            fileList: [],
            fileInfo: {},
            resultVisible: false,
            result: {}
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    batchUpdateHandle = () => {
        this.setState({
            batchAddUserVisible: true,
            fileList: []
        });
    };

    /**
     * 下载模板
     */
    downLoadTem = () => {
        this.request({
            url: "/cm-sites-mmp/rmUser/outputRmUserImportTemplate",
            method: "downloadGet",
            callBack: (res) => {
                if (res) {
                    message.success("下载成功");
                }
            }
        });
    };

    handleOk = () => {
        if (!this.state.fileList.length) {
            message.warn("请上传文件！");
            return;
        }
        if (this.state.fileList[0].status === "uploading") {
            rmtMessage.warning("正在上传，请稍等。");
            return false;
        }
        let url = "/cm-sites-mmp/rmUser/batchImportRmUsers";
        let fd = new FormData();
        fd.append("file", this.state.fileInfo);
        this.request({
            url,
            body: fd,
            method: "post",
            contentType: "upload",
            callBack: (data) => {
                let that = this;
                if (data) {
                    this.state.batchAddUserVisible = false;
                    this.state.result = data;
                    message.success("导入完成");
                    that.state.resultVisible = true;
                    this.props.refreshList();  //刷新列表
                    that.setState({})
                }
            }
        });
    }

    handleCancel = () => {
        this.setState({
            batchAddUserVisible: false
        });
    };

    handleChange = (info) => {
        info.fileList = info.fileList.map(item => {
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                    item.response = info.file.response;
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.path = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.isChunk = true;
                item.status = info.file.status;
                item.md5 = info.file.originFileObj && info.file.originFileObj.md5;
                item.id = info.file.response && info.file.response._id;
            }
            return item;
        });
        let newFileList = info.fileList[info.fileList.length - 1];
        let fileInfo = info.file.originFileObj;
        this.setState({fileList: [newFileList], fileInfo});
    };

    handleRemove = async file => {
        this.setState(prevState => {
            let fileList = prevState.fileList.filter(item => {
                return item._id !== file._id
            });
            return {
                fileList
            }
        });
    };

    handleBeforeUpload = (file) => {
        let fileName = file.name.split('.');
        let upload = fileName.at(-1).toLowerCase();
        upload = ["xlsx", "xls"].includes(upload);
        if (!upload) {
            message.warn('暂不支持该文件类型!');
        }
        return new Promise((resolve, reject) => {
            if (!upload) {
                reject(file);
            } else {
                resolve(file);
            }
        });
    }

    downLoadResult() {
        let params = {
            failId: this.state.result.failId
        }
        this.request({
            url: "/cm-sites-mmp/rmUser/outputFailRmUserList",
            body: params,
            method: "downloadGet",
            callBack: (res) => {
                if (res) {
                    message.success("下载成功");
                }
            }
        });
    }

    render() {
        return (
            <>
                <Button style={{marginRight: "20px"}} onClick={this.batchUpdateHandle}>
                    批量新增用户
                </Button>
                {/*批量新增用户弹窗*/}
                <CmModal
                    handleOk={this.handleOk}
                    handleCancel={this.handleCancel}
                    visible={this.state.batchAddUserVisible}
                    title="批量新增用户"
                    width={500}
                >
                    <div>
                        <Row>
                            <div style={{padding: "10px"}}>
                                <Col span={5}>
                                    <div style={{lineHeight: "30px", textAlign: "right"}}>下载模板：</div>
                                </Col>
                                <Col span={19}>
                                    <Button onClick={this.downLoadTem} type={"link"}>下载导入模板</Button>
                                </Col>
                            </div>
                        </Row>
                        <Row>
                            <div style={{padding: "10px"}}>
                                <Col span={5}>
                                    <div style={{lineHeight: "30px", textAlign: "right"}}><span style={{color: "red"}}>*</span>导入文件：</div>
                                </Col>
                                <Col span={19}>
                                    <UploadWall
                                        showUploadDisplayBtn={true}
                                        style={{width: 320, marginLeft: 15}}
                                        accept={".xlsx,.xls"}
                                        multiple={false}
                                        action="/storage/uploadFile"
                                        customRequest={new ChunkUpload({
                                            checkFileURL: "/storage/checkFile",
                                            checkChunkURL: "/storage/checkChunk",
                                            uploadChunkURL: "/storage/uploadChunk",
                                            chunkUploadOverURL: "/storage/chunkIsUploadOver",
                                            mergeChunksURL: "/storage/mergeChunk",
                                            fileError: (md5, mergeResult, newFile) => {
                                            }
                                        }).start}
                                        showUploadBtn={true}
                                        fileList={this.state.fileList}
                                        listType="list"
                                        onChange={this.handleChange}
                                        beforeUpload={this.handleBeforeUpload}
                                        icons={["delete"]}
                                        onRemove={this.handleRemove}
                                        describe={"支持格式：.xls 、.xlsx 格式"}
                                    />
                                </Col>
                            </div>
                        </Row>
                    </div>
                </CmModal>
                {/*导入结果*/}
                <CmModal
                    handleCancel={() => {
                        this.setState({
                            resultVisible: false
                        })
                    }}
                    visible={this.state.resultVisible}
                    title="导入结果"
                    width={500}
                    footer={null}
                >
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column"
                    }}>
                        <div style={{marginTop: "20px"}}><span>导入成功条数：</span><span
                            style={{color: "#0050b3"}}>{this.state.result.success}</span></div>
                        <div style={{marginTop: "20px"}}><span>导入失败条数：</span><span
                            style={{color: "red"}}>{this.state.result.fail}</span></div>
                        <div style={{margin: "20px 0px"}}><Button type={"primary"} onClick={() => {
                            this.downLoadResult()
                        }}>下载结果</Button></div>
                    </div>
                </CmModal>
            </>
        )
    }
}